import React , {Component} from "react"
import LineHaulFilter from "./LineHaulFilter"
import LineHaulFilterContextProvider from "./context/LineHaulFilterContext";
import LineHaulInfo from "./LineHaulInfo";
import LineHaulContent from "./LineHaulContent";
import LineHaulDetailContextProvider from "./context/LineHaulDetailContext";
import CapabilityContextProvider from "../global/context/ConfigContext";

class LineHaulDetail extends Component {

    render() {
        return (
            <LineHaulFilterContextProvider>
                <CapabilityContextProvider>
                    <LineHaulDetailContextProvider>
                        <LineHaulInfo lineHaul = {this.props.match.params}/>
                        <LineHaulFilter/>
                        <LineHaulContent lineHaul = {this.props.match.params}/>
                    </LineHaulDetailContextProvider>
                </CapabilityContextProvider>
            </LineHaulFilterContextProvider>
        )
    }
}

export default LineHaulDetail


// WEBPACK FOOTER //
// ./src/components/linehaul/LineHaulDetail.js